export default __webpack_public_path__ + "static/18-feff26c784f01144641dc7106c0afd81.gif";